import { AxiosError, AxiosResponse } from 'axios';
import { ErrorType } from '../../../common/dist/common';

export interface ResultSuccess<T> {
  success: true;
  data: T;
}

export interface ResultFailed {
  success: false;
  message: ErrorType;
}

export type Result<T> = ResultSuccess<T> | ResultFailed;

export function makeSuccess<T>(ret: AxiosResponse<T>): ResultSuccess<T> {
  return {
    success: true,
    message: '',
    data: ret.data,
  } as ResultSuccess<T>;
}

function makeError(ret: AxiosError): ResultFailed {
  return {
    success: false,
    message: ret.response?.data || ErrorType.Unknown,
  };
}

export async function toData<T>(p: Promise<AxiosResponse<T>>): Promise<Result<T>> {
  try {
    const ret = await p;
    return makeSuccess(ret);
  } catch (err) {
    return makeError(err);
  }
}

export async function httpStatusToBoolean<T>(p: Promise<AxiosResponse<T>>) {
  try {
    await p;
    return true;
  } catch (e) {
    return false;
  }
}
